import {
    ClockCircleOutlined,
    ContactsOutlined,
    DesktopOutlined,
    FileOutlined,
    MailOutlined,
    StarOutlined,
    TeamOutlined,
    TrophyOutlined
} from '@ant-design/icons';
import { Layout, Menu, theme } from 'antd';
import { useState } from 'react';
import { useAuth } from '../../context/DataContext';
// import { getAuth, signOut } from "firebase/auth";
import AdminContent from './AdminContent';
import ContactFormSubmitted from './ContactFormSubmitted.js';
import JuryDeadlineSettings from './JuryDeadlineSettings';
import OrchestraSettings from './OrchestraSettings';
import PastRegistrantDashboard from './PastRegistrantDashboard';
import PerformerSessionsSettings from './PerformerSessionsSettings';
import PublicCustomersList from './PublicCustomersList';
import RegistrantDashboard from './RegistrantDashboard';
import ScoringRecap from './ScoringRecap';
import SeatingEvent from './SeatEvent.js';
import SeatOccupancy from './SeatOccupancy';
import SystemSettings from './SystemSettings';
import TicketPricingSettings from './TicketPricingSettings';
import VenueSettings from './VenueSettings';

const { Header, Footer, Sider } = Layout;
function getItem(label, key, icon, onClick, children) {
    return {
        label,
        key,
        icon,
        onClick,
        children
    };
}

const AdminDashboard = () => {
    const { signOut } = useAuth();
    const [collapsed, setCollapsed] = useState(false);
    const { token: { colorBgContainer }, } = theme.useToken();

    const [selectedKey, setSelectedKey] = useState('1'); // Initialize with default selected key

    const handleSignOut = () => {
        signOut();
    };

    const onMenuClick = (e) => {
        setSelectedKey(e.key); // Update selected key
    };

    const items = [
        getItem('Contact Form Submitted', '1', <ContactsOutlined />),
        getItem('Registrant Data', '3', <DesktopOutlined />),
        getItem('Past Registrants', '13', <MailOutlined />),
        // getItem('Old Seating Generator', '5', <MailOutlined />),
        getItem('Public Customers', '16', <TeamOutlined />),
        getItem('Ticketing System', 'subTicketing', <DesktopOutlined />, () => { }, [
            getItem('System Settings', '14'),
            getItem('Venue Settings', '17'),
            getItem('Performer Sessions', '19'),
            getItem('Ticket Settings', '18'),
            getItem('Orchestra Settings', '15'),
            getItem('Seat Occupancy', '22'),
            getItem('Admin Page', '2'),
        ]),
        getItem('Scoring Management', 'subJury', <TrophyOutlined />, () => { }, [
            getItem('Scoring Recap', '21', <StarOutlined />),
            getItem('Jury Deadlines', '20', <ClockCircleOutlined />),
        ]),
        // getItem('User', 'sub1', <UserOutlined />, () => { }, [
        //     getItem('Tom', '7'),
        //     getItem('Bill', '8'),
        //     getItem('Alex', '9'),
        // ]),
        // getItem('Team', 'sub2', <TeamOutlined />, () => { }, [getItem('Team 1', '10'), getItem('Team 2', '11')]),
        getItem('Sign out', '12', <FileOutlined />, handleSignOut),
    ];


    const ShowWhichContent = () => {
        switch (selectedKey) {
            case '1':
                return <ContactFormSubmitted />;
            case '2':
                return <AdminContent />;
            case '3':
                return <RegistrantDashboard />;
            // case '4':
            //     return <SeatingContent />;
            case '5':
                return <SeatingEvent />;
            // case '6':
            //     return <GeneralSeat />;
            case '13':
                return <PastRegistrantDashboard />;
            case '14':
                return <SystemSettings />;
            case '15':
                return <OrchestraSettings />;
            case '17':
                return <VenueSettings />;
            case '18':
                return <TicketPricingSettings />;
            case '19':
                return <PerformerSessionsSettings />;
            case '16':
                return <PublicCustomersList />;
            case '20':
                return <JuryDeadlineSettings />;
            case '21':
                return <ScoringRecap />;
            case '22':
                return <SeatOccupancy />;
            default:
                return <ContactFormSubmitted />;
        }
    };

    return (
        <Layout
            style={{
                minHeight: '100vh',
            }}
        >
            <Sider collapsible collapsed={collapsed} onCollapse={(value) => setCollapsed(value)}>
                <div className="demo-logo-vertical" />
                <Menu onClick={onMenuClick} theme="dark" mode="inline" items={items} selectedKeys={[selectedKey]} />
            </Sider>
            <Layout>
                <Header
                    style={{
                        padding: 0,
                        background: colorBgContainer,
                    }}
                />
                {ShowWhichContent()}
                <Footer
                    style={{
                        textAlign: 'center',
                    }}
                >
                    Ant Design ©{new Date().getFullYear()} Created by Ant UED
                </Footer>
            </Layout>
        </Layout>
    )
}

export default AdminDashboard;